import { of, concat } from 'rxjs';
import { switchMap, flatMap, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { ajax, catchApiError } from '@/utils/ajax';

import ActionTypes from './actionTypes';

export const createUser$ = (action$, state$) =>
  action$.pipe(
    ofType(ActionTypes.CREATE_USER),
    switchMap(({ payload: { workspace, invite, user } }) =>
      ajax(
        {
          url: `/users`,
          method: 'POST',
          body: { workspace, invite, user }
        },
        { action$, state$ }
      ).pipe(
        map(res => res.response),
        flatMap(res =>
          of({
            type: ActionTypes.CREATE_USER_SUCCESS,
            payload: res,
            error: true
          })
        ),
        catchApiError(action$, () =>
          of({
            type: ActionTypes.CREATE_USER_FAIL
          })
        )
      )
    )
  );

export default [createUser$];
